<template>
  <div class="">
    <div
      v-if="servicesExist && resultsExist"
      class="SearchResults-services"
    >
      <component
        :is="searchResultComponent"
        v-for="service in featuredResults"
        :key="service.id"
        :result="service"
        :featured="true"
      />
    </div>
    <div
      v-if="resultsExist && !serviceIsAlsoOnlyResult"
      class="SearchResults-results"
      data-cy-id="search-results"
    >
      <component
        :is="searchResultComponent"
        v-for="result in results"
        :key="result.id"
        data-cy-id="search-result-item"
        :result="result"
      />
    </div>
    <div v-else-if="isLoading === false && !serviceIsAlsoOnlyResult">
      <search-no-results />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import jobResult from '../results/job-result.vue';
import reviewResult from '../results/review-result.vue';
import companyResult from '../results/company-result.vue';
import SearchNoResults from '../fallbacks/search-no-results.vue';

export default {
  components: { SearchNoResults },

  data() {
    return {};
  },

  computed: {
    ...mapState('search', {
      searchType: (state) => state.query.show,
      results: (state) => state.results,
      isLoading: (state) => state.uiLoadingState,
      featuredResults: (state) => state.services.featuredResults,
    }),

    searchResultComponent() {
      switch (this.searchType) {
        case 'companies':
          return companyResult;
        case 'reviews':
          return reviewResult;
        case 'jobs':
        default:
          return jobResult;
      }
    },
    servicesExist() {
      return this.featuredResults.length > 0;
    },
    resultsExist() {
      return this.isLoading === false && this.results.length > 0;
    },
    serviceIsAlsoOnlyResult() {
      // See https://rmpenterprise.atlassian.net/browse/RMA-3308
      if (
        this.isLoading === false
        && this.results.length === 1
        && this.featuredResults.length === 1
      ) {
        return this.featuredResults[0].id === this.results[0].id;
      }

      return false;
    },
  },
};
</script>
